import { render, staticRenderFns } from "./ChapterOverview.vue?vue&type=template&id=60cef6eb&"
import script from "./ChapterOverview.vue?vue&type=script&lang=js&"
export * from "./ChapterOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports